import { GoogleAuthProvider } from "firebase/auth";
export const googleProvider = new GoogleAuthProvider();